import i18next from 'i18next';
import * as Yup from 'yup';

import { SHOP_WEBHOOK_AMOUNT_OFFSET_MAX } from 'constants/shops.constants';
import { Shop } from 'types';

const normalize = (rows: Shop['webhookOverrides']) =>
  (rows || []).map(({ orderCurrencyId, orderPaymentTypeId, amountOffset }) => ({
    orderCurrencyId,
    orderPaymentTypeId,
    amountOffset,
  }));

const getValidationSchema = () => {
  const keyPrefix = 'features.shops.manage.sections.webhook_overrides';

  return Yup.array()
    .of(
      Yup.object().shape({
        orderCurrencyId: Yup.string()
          .uuid(i18next.t('errors.invalid_uuid'))
          .required(i18next.t('errors.required')),
        orderPaymentTypeId: Yup.string()
          .uuid(i18next.t('errors.invalid_uuid'))
          .required(i18next.t('errors.required')),
        amountOffset: Yup.number()
          .typeError(i18next.t('errors.natural_or_zero_number'))
          .min(0, i18next.t('errors.natural_or_zero_number'))
          .max(
            SHOP_WEBHOOK_AMOUNT_OFFSET_MAX,
            `${i18next.t('errors.max')} ${SHOP_WEBHOOK_AMOUNT_OFFSET_MAX}`,
          )
          .test(
            'finite',
            i18next.t('errors.natural_or_zero_number'),
            (value) => value == null || Number.isFinite(value),
          )
          .required(i18next.t('errors.required')),
      }),
    )
    .test('unique-pair', function (rows) {
      const duplicateIndex = rows?.findIndex(
        (row, index) =>
          row.orderCurrencyId &&
          row.orderPaymentTypeId &&
          rows.findIndex(
            (other) =>
              other.orderCurrencyId === row.orderCurrencyId &&
              other.orderPaymentTypeId === row.orderPaymentTypeId,
          ) !== index,
      );

      return duplicateIndex != null && duplicateIndex >= 0
        ? this.createError({
            path: `${this.path}[${duplicateIndex}].orderPaymentTypeId`,
            message: i18next.t(`${keyPrefix}.duplicate_pair`),
          })
        : true;
    });
};

export const shopWebhookOverridesUtils = { normalize, getValidationSchema };
